import React, {
  useState,
  forwardRef,
  ForwardRefRenderFunction,
  useEffect,
} from "react";
import { Checkbox, Input } from "sr/helpers";
import { FormattedMessage, useIntl } from "react-intl";
import { useFormik } from "formik";
import { jobtypeSchema } from "sr/utils/schemas/cleaner/jobtypeSchema";
import { createJobtype } from "sr/utils/api/cleaner/createJobtype";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { CleanerComponentProps } from "./CleanerComponentProps";
import { getJobType } from "sr/utils/api/cleaner/getJobType";
import { updateJobType } from "sr/utils/api/cleaner/updateJobType";
import ContentWithSpinner from "sr/layout/common/ContentWithSpiner";
import { ButtonAuth } from "sr/helpers/ui-components/ButtonAuth";
import { ReactSelect } from "sr/helpers/ui-components/ReactSelect";
import { LoaderFullScreen } from "sr/layout/common/LoaderFullScreen";
import { getJobTypeCategory } from "sr/utils/api/getJobTypeCategory";
import { toast } from "react-toastify";
import getLabelByValue from "sr/helpers/functions/getLabelByValue";
import { deleteJobType } from "sr/utils/api/cleaner/deleteJobType";
import { Pageination } from "sr/helpers/ui-components/Pageination";
import { createIndIntersted } from "sr/utils/api/cleaner/indInterested/createIndIntersted";
import { getIndIntersted } from "sr/utils/api/cleaner/indInterested/getIndIntersted";
import DropDown from "sr/helpers/ui-components/DropDown.tsx";
import { STRIPE_CONNECT_COUNTRIES } from "sr/constants/common";
import { getUserFullProfile } from "sr/utils/api/user/user";
import { stripeConnectOnboardingSchema } from "sr/utils/schemas/cleaner/stripeConnectOnboardingSchema";
import { createStripeConnectOnboarding } from "sr/utils/api/cleaner/createStripeConnectOnboarding";

const AddStripeConnectAccount: ForwardRefRenderFunction<
  any,
  CleanerComponentProps
> = (
  {
    HandleStepper = null,
    page = "",
    type = "",
    dataAddedHandle = null,
    id = "",
  },
  ref,
) => {
  const [loader, setLoader] = useState(false);
  const intl = useIntl();
  const [buttonLoader, setButtonLoader] = useState(false);
  const [userData, setUserData] = useState(null);
  const [data, setData] = useState(null);
  const [resInterested, setResInterested] = useState(true);

  useEffect(() => {
    (async () => {
      const getdetails = await getUserFullProfile();
      if (getdetails?.success && getdetails?.data) {
        setUserData(getdetails?.data);
        setFieldValue("email", getdetails?.data?.email);
      }
    })();
  }, []);
  const initialValues = {
    email: "",
    country: "US",
  };

  const {
    handleChange,
    setFieldValue,
    setFieldTouched,
    handleSubmit,
    errors,
    values,
  } = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    onSubmit: async (values, helpers) => {
      try {
        setButtonLoader(true);
        let result;

        const payload = {
          country: values?.country,
          return_url: `${window.location.origin}/cleaner-profile-page/#section-10`,
        };
        console.log("payload", payload);

        // create stripe connect account
        result = await createStripeConnectOnboarding(payload);

        if (result?.success === true) {
          console.log("result", result.data);
          if (result.data && result.data.on_boarding_url) {
            window.location.href = result.data.on_boarding_url;
            setLoader(false);
            setButtonLoader(false);
            dataAddedHandle(true);
          }
          // if (page === "popup") {
          //   // dataAddedHandle(true);
          // }
          // if (HandleStepper !== null) {
          //   // HandleStepper(4);
          // }
        } else {
          // toast.error(intl.formatMessage({ id: result?.success, defaultMessage: result?.success }));
          setLoader(false);
          setButtonLoader(false);
        }
      } catch (e) {
        setLoader(false);
        setButtonLoader(false);
      }
    },
    validationSchema: stripeConnectOnboardingSchema,
  });
  const submitForm = async () => {
    handleSubmit();
  };
  React.useImperativeHandle(ref, () => ({
    submitForm,
  }));

  return (
    <ContentWithSpinner loader={loader}>
      {buttonLoader && <LoaderFullScreen />}

      <DropDown
        value={values.country}
        onChange={(e: any) => {
          handleChange(e);
          if (e?.target?.name) {
            setFieldTouched(e.target.name, true, false);
          }
        }}
        // onBlur={handleBlur}
        name="country"
        label={intl.formatMessage({
          id: "CLEANER.PROFILE.PREFERENCES.SHIFTTYPE",
          defaultMessage: "Select Shift Type",
        })}
      >
        {STRIPE_CONNECT_COUNTRIES.map((data, index) => (
          <option key={index} value={data.iso}>
            {" "}
            <FormattedMessage
              id={data.name}
              defaultMessage={data.name}
            ></FormattedMessage>{" "}
          </option>
        ))}
      </DropDown>
      <Input
        value={values.email}
        error={errors.email}
        label={intl.formatMessage({
          id: "RECRUITER.ACCOUNT.SETTINGS.EMAIL.TITLE",
          defaultMessage: "Email",
        })}
        type="email"
        disabled
        placeholder={intl.formatMessage({
          id: "RECRUITER.CUSTOMER.INPUT.EMAIL.PLACEHOLDER",
          defaultMessage: "Enter Email Address",
        })}
        name="email"
      ></Input>

      {page === "popup" ? (
        ""
      ) : (
        <>
          <div className="mt-5 flex space-x-5">
            <ButtonAuth onClick={submitForm} loader={buttonLoader}>
              <FormattedMessage
                id="REGISTER.BUTTON.SAVEANDCONTINUE"
                defaultMessage="Save and Continue"
              />
            </ButtonAuth>
            {data?.length > 0 && (
              <div
                className="rounded-full text-center
                 bg-[#ff39b3] font-bold
                 p-2
                 text-white
                 w-44
                 cursor-pointer mb-5 mt-5
                 hover:bg-navy"
                onClick={() => HandleStepper(4)}
              >
                Skip
              </div>
            )}
          </div>
        </>
      )}
    </ContentWithSpinner>
  );
};
export default forwardRef(AddStripeConnectAccount);
